import React, { useState, useEffect, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";

const initialValues = {
  recommendationName: "",
  image: null,
  recommendationTag: "Cool Area",
};

const CoolAreasForm = ({ setFormView, setUpdateData }) => {
  const [formData, setFormData] = useState(initialValues);
  const thumbnailRef = useRef(null);

  const onThumbnailButtonClick = () => {
    thumbnailRef.current.click();
  };

  const clearState = () => {
    setFormData(initialValues);
    setFormView(false);
  };

  const uploadRecommendation = () => {
    addRecommendation();
    clearState();
  };

  const addRecommendation = async () => {
    try {
      const res = await axios.post(
        "https://resto-app-user.herokuapp.com/recommendation/add-cool-area",
        formData
      );
      const recommendationId = res.data.data._id;
      const imageUpload = new FormData();
      imageUpload.append("imageUpload", formData.image);
      const res1 = await axios.post(
        "https://resto-app-user.herokuapp.com/recommendation/upload-cool-area-image/" +
          recommendationId,
        imageUpload
      );
      setUpdateData((prev) => prev + 1);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="px-5 py-3 my-3 border border-gray-300 rounded-sm flex flex-row gap-x-4 md:flex-row">
      <div className="w-6/12  flex flex-row  md:flex-col ">
        <div className="w-full svelte-1l8159u">
          <div className="bg-white my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
            <input
              value={formData.recommendationName}
              onChange={(e) =>
                setFormData({ ...formData, recommendationName: e.target.value })
              }
              placeholder="Type recommendation name..."
              className="py-1 px-1 m-0 appearance-none outline-none w-full text-gray-800"
            />{" "}
          </div>
        </div>
      </div>
      <div className="bg-white w-3/12 flex flex-col justify-center">
        {formData.image === null ? (
          <button
            className="w-full bg-indigo-600 text-white py-2 px-3 rounded-sm border-none"
            onClick={onThumbnailButtonClick}
          >
            Choose Image
            <input
              type="file"
              ref={thumbnailRef}
              onChange={(e) =>
                setFormData({ ...formData, image: e.target.files[0] })
              }
              style={{ display: "none" }}
            />
          </button>
        ) : (
          <button
            className="w-full bg-green-600 text-white py-2 px-3 rounded-sm border-none"
            onClick={onThumbnailButtonClick}
          >
            {formData.image.name.substring(0, 15)}
            <input
              type="file"
              ref={thumbnailRef}
              onInput={(e) => {
                setFormData({ ...formData, image: e.target.files[0] });
              }}
              style={{ display: "none" }}
            />
          </button>
        )}
      </div>
      <div className="w-2/12 flex flex-col justify-center">
        <button
          className="w-full bg-green-500 text-white py-2 px-3 rounded-sm border-none"
          onClick={(e) => {
            if (formData.image !== null && formData.recommendationName !== "") {
              uploadRecommendation();
            }
          }}
        >
          Add
        </button>
      </div>
      <div className="w-1/12 flex flex-col justify-center">
        <button
          className="w-full bg-red-500 text-white py-2 px-3 rounded-sm border-none"
          onClick={clearState}
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};

export default CoolAreasForm;
